module.exports = __webpack_public_path__ + "media/Q6.52106d4e.mp4";